import {Component, OnInit, ViewChild} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {ExgDataTableComponent, ExgModalService} from 'exc-controls-v2';
import {ExcSecurityService} from 'exc-security-v2';
import {ExcFileItem} from 'exc-upload-v2';
import {ApplicationService} from '../services/application.service';
import {VideoService} from '../services/video.service';

@Component({
  selector: 'app-library',
  templateUrl: './library.component.html'
})
export class LibraryComponent extends ExcTranslation implements OnInit {
  @ViewChild('Libraries', {read: ExgDataTableComponent}) dt!: ExgDataTableComponent;
  @ViewChild('SubContect', {read: ExgDataTableComponent}) subDt!: ExgDataTableComponent;
  excRestServiceCore = ExcCoreModule.Services().ExcRest;
  data = [] as any[];
  metaInfo: any = {dataFilter: {}, dataPaging: {}, dataSort: {}};
  searchValue = '';
  libraryList = [] as any[];
  libraryContent = [] as any[];
  selectedLibrary = {} as any;
  selectedContent = {} as any;
  folderFilter = {} as any;
  libSearch = {} as any;
  folderSearch = {} as any;
  breadcrumbs = [] as any[];
  libKey = '';
  selectedLibIndex = 0;
  uploadSelectedFiles: ExcFileItem[] = [];
  infoDrawerActive = false;
  clientsList = [] as any [];
  tableState = 0;
  libTableState = 0;

  constructor(
    private modalService: ExgModalService,
    public excSecurity: ExcSecurityService,
    public appSvc: ApplicationService,
    private videoService: VideoService
  ) {
    super();
  }

  ngOnInit(): void {
    this.getInitilalData();
  }

  getInitilalData(): void {
    const _self = this;
    _self.tableState = 1;
    _self.libTableState = 1;
    const url = _self.excRestServiceCore.computeUrl('LibraryList', {});
    this.excRestServiceCore.sget(url, ExcCoreModule.Guid.NewGuid(), {MetaInfo: this.metaInfo}).subscribe((ret: any) => {
      if (ret.success && ret.data && ret.data.Libraries.length > 0) {
        _self.data = ret.data.Libraries;
        _self.clientsList = ret.data.Clients;
        _self.parseLibs();
        if (_self.libKey !== '') {
          this.folderFilter = _self.libKey;
          this.exploreContent();
        } else {
          this.onRowSelect(this.selectedLibIndex);
          this.dt.selectedRow = 0;
        }
        // this.onRowSelect(this.selectedLibIndex);
        _self.tableState = 0;
        _self.libTableState = 0;
        if (_self.libraryContent.length === 0) {
          _self.tableState = 2;
          // this.dt.selectedRow = -1;
        }
      }
      else{
        _self.tableState = 2;
        _self.libTableState = 2;
      }
      this.folderFilter = null;
      _self.libKey = '';
    });
  }
  onRowSelect(index: number): void {
    this.selectedLibIndex = index;
    const _self = this;
    if (_self.libKey === '') {
      _self.folderFilter = null;
      _self.breadcrumbs = [];
    }
    _self.folderSearch = null;
    _self.selectedLibrary = this.libraryList[index];
    _self.exploreContent();
    _self.onContentRowSelect(0);
  }
  onContentRowSelect(index: number): void {
    const _self = this;
    _self.selectedContent = null;
    _self.folderFilter = null;
    _self.folderSearch = null;
    _self.selectedContent = this.libraryContent[index];
    // if (this.selectedContent) {
    //   this.selectedContent.libComment = '';
    // }
    // _self.breadcrumbs = [];
  }
  getFileFolderClass(item: any): string {
    if (item.libType === 'Folder') {
      return 'fa-folder';
    }
    switch (item.libExtension) {
      case 'doc':
      case 'docx':
        return 'fa-file-word';
      case 'xls':
      case 'xlsx':
        return 'fa-file-excel';
      case 'pdf':
        return 'fa-file-pdf';
      case 'jpg':
      case 'jpeg':
      case 'gif':
      case 'tiff':
      case 'png':
      case 'bmp':
        return 'fa-image';
      case 'webm':
      case 'mp4':
      case 'mov':
      case 'wmv':
      case 'avi':
      case 'avchhd':
      case 'flv':
      case 'f4v':
      case 'swf':
      case 'mkv':
        return 'fa-film';
      default:
        return 'fa-file';
    }
  }

  onContentClick(index: any): void {
    const item = this.libraryContent[index];
    if (item.libType === 'File') {
      if (this.videoService.isVideo(item)) {
        this.videoService.openVideo(item);
        return;
      }
      if (item.libMimeType.includes('application/pdf') || item.libMimeType.includes('image/')) {
        this.appSvc.file.library.openInBrowser(item);
      } else {
        this.modalService
          .showToast(
            `${this.getRessource('DownloadStart')}`
            , `md-toast bg-green`
            , 'fal fa-download'
          );

        window.location.href = this.excRestServiceCore.computeUrl('LibraryDetail', {libID: item.libID});
      }
    }
    else if (item.libType === 'Folder') {
      this.folderFilter = item.libKey;
      this.breadcrumbs.push(item);
      this.exploreContent();
    }
  }

  exploreContent(): void {
    this.libraryContent = [];
    const flt = this.folderFilter === null ? this.selectedLibrary.libKey : this.folderFilter;
    for (const l of this.data) {
      if (l.libKey.indexOf(flt) === 0 && l.libKey !== flt) {
        if (this.folderSearch !== null && this.folderSearch.length > 0) {
          if (l.libDescription.toLowerCase().indexOf(this.folderSearch.toLowerCase()) > -1) {
            this.libraryContent.push(l);
          }
        }
        else {
          if (l.libKey.length === flt.length + 5) {
            this.libraryContent.push(l);
          }
        }
      }
    }
    if (this.libraryContent.length !== 0) {
      this.tableState = 0;
      this.subDt.selectedRow = 0;
    } else {
      this.tableState = 2;
      this.subDt.selectedRow = -1;
    }
  }
  parseLibs(): void {
    this.libraryList = [];
    for (const l of this.data) {
      if (l.libKey.indexOf('.') === -1) {
        if (this.libSearch !== null && this.libSearch.length > 0) {
          if (l.libDescription.toLowerCase().indexOf(this.libSearch.toLowerCase()) > -1) {
            this.libraryList.push(l);
          }
        }
        else {
          this.libraryList.push(l);
        }
      }
    }
  }
  onSearch(e: string): void {
    const _self = this;
    _self.libSearch = e;
    this.parseLibs();
  }
  onContentSearch(e: string): void {
    const _self = this;
    _self.folderSearch = e;
    this.exploreContent();
  }
  addNewLibrary(): void {
    const _self = this;
    const clID = '00000000-0000-0000-0000-000000000000';
    const data = {
      libDescription: null,
      libComment: null,
      isLibrary : true
    };
    this.modalService.show('ModalCreateLibraryComponent', data).subscribe(rslt => {
      if (rslt) {
        const dataObject = {
          libDescription: rslt.libName,
          libComment: rslt.libComment
        };
        const url = _self.excRestServiceCore.computeUrl('LibraryC', {clID});
        _self.excRestServiceCore.post(url, dataObject).subscribe((ret: any) => {
          _self.getInitilalData();
        });
      }
    });
  }
  addNewFolder(): void {
    const _self = this;
    _self.libKey = '';
    _self.libKey =  _self.getLibKey();
    const data = {
      libDescription: null,
      libComment: null,
      isLibrary : false
    };
    this.modalService.show('ModalCreateLibraryComponent', data).subscribe(rslt => {
      if (rslt) {
        const dataObject = {
          RootKey:  _self.libKey,
          libDescription: rslt.libName,
          libComment: rslt.libComment
        };
        const url = _self.excRestServiceCore.computeUrl('LibraryC_NewDirectory', {clID: _self.selectedLibrary.lib_clID});
        _self.excRestServiceCore.post(url, dataObject)
          .subscribe((ret: any) => {
          _self.getInitilalData();
        });
      }
    });
  }

  uploadDocuments(files: ExcFileItem): void {
    const uploadCount = 1;
    let uploadProgress = 0;
    let lastValue = 0;

    const _self = this;
    _self.libKey = '';
    _self.libKey =  _self.getLibKey();
    _self.uploadSelectedFiles = this.uploadSelectedFiles.concat(files);
    const formData = ExcFileItem.getFormData(_self.uploadSelectedFiles, {});

    if (formData) {
      formData.set('DataObject', JSON.stringify({clID: _self.selectedLibrary.lib_clID, RootKey:  _self.libKey }));

      this.excRestServiceCore.post(
        this.excRestServiceCore.computeUrl('LibraryC_File',
        {
          clID: _self.selectedLibrary.lib_clID,
          RootKey:  _self.libKey
        }), formData
          , {
            OnProgress: (value: any) => {
              uploadProgress -= lastValue;
              uploadProgress += value - 1;

              this.showRequestProgress(uploadProgress, uploadCount);

              lastValue = value - 1;
            }
          }
        ).subscribe(
          (ret: any) => {
            if (ret) {
              this.getInitilalData();
            }
          }
          , (ret: any) => {

          }, () => {
            uploadProgress += 1;

            if (uploadProgress === uploadCount * 100) {
              this.modalService
                .showToast(
                  `${this.getGlobal('Success')}`
                  , `md-toast bg-green`
                  , 'fal fa-cloud-upload-alt'
                );
            }
          }
        );
    }
    this.uploadSelectedFiles = [];
  }

  showRequestProgress(uploadProgress: any, uploadCount: any): void {
    this.modalService
      .showToast(
      `${Math.round(uploadProgress / uploadCount)} % hochgeladen`
      , 'md-toast app-opacity'
      , 'fad fa-cloud-upload-alt');
  }

  editLibrary(): void {
    const _self = this;
    const data = {
      libDescription: _self.selectedLibrary.libDescription,
      libComment: _self.selectedLibrary.libComment,
      isLibrary : true
    };
    this.modalService.show('ModalCreateLibraryComponent', data
    ).subscribe(rslt => {
      if (rslt){
        const dataObject = {
          libDescription: rslt.libName,
          libComment: rslt.libComment
        };
        const url = _self.excRestServiceCore.computeUrl('LibraryU', {libID: _self.selectedLibrary.libID});
        _self.excRestServiceCore.put(url, dataObject).subscribe((ret: any) => {
          _self.selectedLibrary.libComment = rslt.libComment;
          _self.getInitilalData();
        });
      }
    });
  }

  editFolder(): void {
    const _self = this;
    const data = {
      libDescription: _self.selectedContent.libDescription,
      libComment: _self.selectedContent.libComment,
      isLibrary : false
    };
    this.modalService.show('ModalCreateLibraryComponent', data
    ).subscribe(rslt => {
      if (rslt){
      const dataObject = {
        libDescription: rslt.libName,
        libComment: rslt.libComment
      };
      const url = _self.excRestServiceCore.computeUrl('LibraryU', {libID: _self.selectedContent.libID});
      _self.excRestServiceCore.put(url, dataObject).subscribe((ret: any) => {
        const dir = ret.data[0];
        this.selectedContent.libComment = dir.libComment;
        this.selectedContent.libDescription = dir.libDescription;
        // this.selectedContent.libComment = data.libComment;
      });
      }
    });
  }

  goBreadcrumb(index: any): void {
    if (this.breadcrumbs[index]){
      const b = this.breadcrumbs[index];
      this.folderFilter = b.libKey.substring(0, b.libKey.length - 5);
      this.breadcrumbs.splice(this.breadcrumbs.indexOf(b));
      this.exploreContent();
    }
  }

  showInfo(): void {
    const infoData = {
      libID:  this.selectedLibrary.libID,
      libComment: this.selectedLibrary.libComment,
      isLibrary : true
    };
    if (this.selectedLibrary) {
      this.modalService.show('ModalLibraryInfoComponent', infoData).subscribe(data => {
      });
      this.infoDrawerActive = !this.infoDrawerActive;
    }
  }

  levelUp(): void {
    if (this.breadcrumbs !== []) {
      this.goBreadcrumb(this.breadcrumbs.length - 1);
      this.subDt.selectedRow = 0;
    }
  }

  editFileInfo(): void {
    const _self = this;
    const infoData = {
      libID:  this.selectedContent.libID,
      libComment: this.selectedContent.libComment,
      isLibrary : false
    };
    if (this.selectedContent) {
      this.modalService.show('ModalLibraryInfoComponent', infoData).subscribe(data => {
        if (data){
          if (data.libComment){
              const dataObject = {
                libDescription: this.selectedContent.libDescription,
                libComment: data.libComment
              };
              const url = _self.excRestServiceCore.computeUrl('LibraryU', {libID: _self.selectedContent.libID});
              _self.excRestServiceCore.put(url, dataObject).subscribe((ret: any) => {
                this.selectedContent.libComment = data.libComment;
              });
          }
        }
      });
    }
  }

  deleteLibContent(): void {
    const _self = this;
    let warningText = '';
    if (this.selectedContent.libType === 'Folder') {
      warningText = this.getRessource('ModalDeleteFolderHeader');
    } else {
      warningText = this.getRessource('ModalDeleteFileHeader');
    }
    _self.modalService.showSimple(this.getRessource('Delete'),
      warningText, true, true,
      this.getGlobal('Yes'), this.getGlobal('No')).subscribe(args => {
      if (args) {
        const url = this.excRestServiceCore.computeUrl('LibraryD', {libID: this.selectedContent.libID});
        this.excRestServiceCore.delete(url, {libUPT: this.selectedContent.libUPT}).subscribe((ret: any) => {
          if (ret.success) {
            _self.libKey = _self.getLibKey();
            _self.getInitilalData();
          }
        });
      }
    });
  }

  deleteLib(): void {
    const _self = this;
    _self.modalService.showSimple(this.getRessource('Delete'),
      this.getRessource('ModalDeleteFolderHeader'), true, true,
      this.getGlobal('Yes'), this.getGlobal('No')).subscribe(args => {
      if (args) {
        const url = this.excRestServiceCore.computeUrl('LibraryD', {libID: this.selectedLibrary.libID});
        this.excRestServiceCore.delete(url, {libUPT: this.selectedLibrary.libUPT}).subscribe((ret: any) => {
          if (ret.success) {
            _self.libKey = _self.getLibKey();
            if (ret.data) {
              _self.dt.selectedRow = 0;
            }
            _self.getInitilalData();
          }
        });
      }
    });
  }

  refreshContent(): void {
    const _self = this;
    _self.libKey = _self.getLibKey();
    _self.getInitilalData();
  }

  getLibKey(): any {
    const _self = this;
    let libKeyStr = '';
    if (this.breadcrumbs.length > 0){
      libKeyStr = this.breadcrumbs[this.breadcrumbs.length - 1].libKey;
    }
    else {
      libKeyStr = _self.selectedLibrary.libKey;
    }
    return libKeyStr;
  }
}
